import './polyfills';
import React from "react";
import ReactDOM from "react-dom";
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import createSagaMiddleware from 'redux-saga';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import TagManager from './gtm';
import reportWebVitals from './reportWebVitals';
import configurationReducer from './redux/reducers/configuration';
import { getConfiguration } from './redux/actions/configuration';
import rootSaga from './sagas';
import Main from './pages/Main';
import GlobalError from './components/organisms/GlobalError/GlobalError';
import { PATH_PAGE_LOCALE_DEFAULT, REACT_APP_GTM_ID, REACT_APP_KEY_COOKIE_SCRIPT } from './constants';

import './tailwind.compiled.css';
import './index.scss'; // Main styles with proper cascade
import './overrides.css'; // Only critical overrides, minimal !important usage

// Parse query parameters properly to support GTM Preview and other query params
const urlParams = new URLSearchParams(window.location.search);
let locale = urlParams.get('locale');

if(!locale){
    urlParams.set('locale', PATH_PAGE_LOCALE_DEFAULT);
    const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + urlParams.toString();
    window.history.pushState({path:newurl},'',newurl);
    locale = PATH_PAGE_LOCALE_DEFAULT;
}

const sagaMiddleware = createSagaMiddleware();
const store = createStore(
  configurationReducer,
  applyMiddleware(sagaMiddleware)
);

sagaMiddleware.run(rootSaga);
store.dispatch(getConfiguration(locale));

// GTM Configuration - Conditionally initialize based on locale
const GTM_IDS = {
  'pt_PT': 'GTM-TM4GKJ93',
  'es_ES': 'GTM-N2LQ9DNV'
};

const currentLocale = locale || PATH_PAGE_LOCALE_DEFAULT;
const gtmId = GTM_IDS[currentLocale] || REACT_APP_GTM_ID;

const tagManagerArgs = {
  gtmId: gtmId
}

console.log(`Initializing GTM for locale: ${currentLocale} with ID: ${gtmId}`);

// Cookie Consent Banner - Only load in production
// if (process.env.NODE_ENV === 'production') {
//   const sdkScript = document.createElement('script');
//   sdkScript.src = 'https://consent.cookiebot.com/uc.js';
//   sdkScript.type = 'text/javascript';
//   sdkScript.setAttribute('data-cbid', REACT_APP_KEY_COOKIE_SCRIPT);
//   sdkScript.setAttribute('data-blockingmode', "auto");
//   sdkScript.id = 'Cookiebot';

  //const consentScript = document.createElement('script');
  //consentScript.src = `https://cdn.cookielaw.org/consent/${REACT_APP_KEY_COOKIE_SCRIPT}/OtAutoBlock.js`;
  //consentScript.type = 'text/javascript';
  //consentScript.id = 'consentScript';

  //document.head.appendChild(consentScript);
//   document.head.appendChild(sdkScript);
// } else {
//   console.log('Cookiebot disabled in development environment');
// }

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <Provider store={store}>
    <GlobalError>
      <Main />
    </GlobalError>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
